import { Component, Input, Output, EventEmitter } from '@angular/core';
import { ContactData } from '../../../interfaces/contact-data';

/**
 * Generated class for the ContactAddressComponent component.
 */
@Component({
  selector: 'contact-address',
  templateUrl: 'contact-address.html',
  styleUrls: ['./contact-address.scss']
})
export class ContactAddressComponent {

  @Input()
  contractData: ContactData;

  @Input()
  isEdit?: boolean;

  @Output()
  outContractData = new EventEmitter();

  changeData(key: string, val: any) {
    this.contractData[key] = val;
    this.outContractData.emit(this.contractData);
  }

  constructor() {

  }

}
